export default {
  sentryDSN: process.env.REACT_APP_SENTRY_DSN,
  MATOMO_URL: process.env.REACT_APP_MATOMO_URL,
  MATOMO_ENV: process.env.REACT_APP_MATOMO_ENV,
};
